export default "__VITE_ASSET__2e4e8d00__"